import React, { useMemo } from "react";
import TableContainer from "../../../components/Common/TableContainer";
import { getAuthUser } from "../../../helpers/auth";


type Data = {
  // @ts-ignore
  account: string;
  [day: string]: {
    checkin_time: string;
    checkout_time: string;
    workTime: string;
    totalBreakTime: string;
    total_break: number
    color: string;
    sickDay: number;
    remoteDay:number;
    totalImportantTime: string;
    totalDinnerTime: string;
  };
};

const TableCheck = (props: any) => {
  const { data, daysInMonth } = props;
  //const { data: login } = useSelector((state: any) => state.login)
  const login = getAuthUser();
  const isAdmin = (login?.roles || []).some((item: any) => item?.name === "admin");

  const formatData = (data: Data[]) => {
    return data?.map((item: any) => {
      const formattedItem: Data = {
        account: item?.account ?? item?.name ?? "",
      };
      daysInMonth.forEach((day: keyof Data) => {
        const dayData = item?.[day] || {};
        formattedItem[day] = {
          checkin_time: dayData.checkin_time ?? "00:00",
          checkout_time: dayData.checkout_time ?? "00:00",
          color: String(dayData.color ?? ""),
          remoteDay: dayData.remoteDay ?? 0,
          sickDay: dayData.sickDay ?? 0,
          total_break: dayData.total_break ?? 0,
          workTime: dayData.workTime ?? "00:00",

          totalBreakTime: dayData.totalBreakTime ?? "00:00",
          totalDinnerTime: dayData.totalDinnerTime ?? "00:00",
          totalImportantTime: dayData.totalImportantTime ?? "00:00",
        };
      });
      return formattedItem;
    });
  };

  const formattedData = useMemo(() => {
    return formatData(data);
  }, [data, daysInMonth]);

  const columns = useMemo(
    () => [
      {
        Header: 'Account',
        accessor: 'account',
        disableFilters: true,
      },
      ...daysInMonth.map((day: any) => ({
        Header: day,
        accessor: day,
        disableFilters: true,
        Cell: ({ value }: { value: Data[keyof Data] }) => (
          <div style={{ minWidth: '175px', width: 'auto' }}>
            <div style={{ color: value.color }}>
              At work: <span style={{ fontWeight: 'bold' }}>{value.checkin_time}</span>
            </div>
            <div>Left work: {value.checkout_time}</div>
            <div>Total break: {value.total_break}</div>
            <div>Total break time: {value.totalBreakTime}</div>
            <div>Total dinner time: {value.totalDinnerTime}</div>
            <div>Work Time: {value.workTime}</div>
            {isAdmin && (
              <>
                <div>Sick Day: {value.sickDay}</div>
                <div>Remote Day: {value.remoteDay}</div>
                <div>Dinner Time: {value.totalDinnerTime}</div>
                <div>Important Time: {value.totalImportantTime}</div>
              </>
            )}
          </div>
        ),
      })),
    ],
    [daysInMonth, isAdmin]
  );

  return (
    <>
      <TableContainer
        columns={columns}
        data={formattedData}
        isGlobalFilter={false}
        customPageSize={10}
        className="table align-middle datatable dt-responsive table-check checkin-table nowrap"
        theadClass={{ width: "100%", }}
      />
    </>
  )
}

export default React.memo(TableCheck);
